import { Loader2 } from "lucide-react";

export const Spinner = ({ className = "" }) => (
  <div className={`flex justify-center py-12 ${className}`} data-testid="loading-spinner">
    <Loader2 className="h-6 w-6 animate-spin text-tm-green-light" />
  </div>
);

export const FullPageLoader = () => (
  <div className="min-h-screen grid place-items-center bg-tm-sand">
    <Spinner />
  </div>
);

export const EmptyState = ({ icon: Icon, title, text, action, testid }) => (
  <div className="tm-card p-10 text-center" data-testid={testid}>
    {Icon && <Icon className="mx-auto h-8 w-8 text-tm-gold" />}
    <h3 className="mt-3 text-lg font-semibold text-tm-green">{title}</h3>
    {text && <p className="mt-1 text-sm text-slate-600">{text}</p>}
    {action && <div className="mt-5">{action}</div>}
  </div>
);
